// The metric row: three to five figures sitting straight on the canvas or
// in one panel. Kpi takes a label and a value; lead makes one number louder
// per screen. Values are strings the screen already formatted; the Kpi does
// no math and no formatting.

import './kpi.css'

export function KpiRow({ className = '', children }) {
  return <div className={`ui-kpis${className ? ` ${className}` : ''}`}>{children}</div>
}

export function Kpi({ label, value, lead = false }) {
  return (
    <div className={`ui-kpi${lead ? ' ui-kpi-lead' : ''}`}>
      <span className="label">{label}</span>
      <span className="ui-kpi-value">{value}</span>
    </div>
  )
}
